import { get, post} from '@/request/http'
//年度各指标数值和同比
export const getindexdata = (params) => get('/api/home/getindexdata', params)

//获取口径
export const getbores = (params) => get('/api/home/getbores', params)

//获取城市列表
export const getcitys = (params) => get('/api/home/getcitys', params)

//获取模块列表
export const getmoduls = (params) => get('/api/home/getmoduls', params)

//获取指标列表
export const gettargets = (params) => get('/api/home/gettargets', params)


// WEBPACK FOOTER //
// ./src/api/ranking.js